export function UTCDateToLocale(
  utc: string | Date | null | undefined
): Date | null {
  if (!utc) {
    return null;
  }
  const tempDate = new Date(utc);
  const date = new Date(
    Date.UTC(
      tempDate.getFullYear(),
      tempDate.getMonth(),
      tempDate.getDate(),
      tempDate.getHours(),
      tempDate.getMinutes(),
      tempDate.getSeconds(),
      tempDate.getMilliseconds()
    )
  );
  return date;
}
